// Admin configuration — secrets come from env vars at build time
export const API_URL = import.meta.env.VITE_API_URL || 'https://simpleclair-dashboard-api.brunel-michael.workers.dev';
export const ADMIN_KEY = import.meta.env.VITE_ADMIN_KEY || '';

export function getAdminHeaders(): Record<string, string> {
  return { 'Authorization': `Bearer ${ADMIN_KEY}` };
}
